export default "assets/javascripts/dist/emojis@2x.png";